/**
 * The phone's place in a game (projects/trivia D5): the player token
 * join/ returned, kept so a reload or a locked screen rejoins as the same
 * player. Storage can be off (private mode) or throw; then the page still
 * plays, it just can't survive a reload.
 */

const KEY = "trivia.player";

export function loadSession() {
  try {
    const value = JSON.parse(window.localStorage.getItem(KEY) || "null");
    return value && typeof value.token === "string" ? value : null;
  } catch {
    return null;
  }
}

export function saveSession(session) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(session));
  } catch {
    // Storage is off: this tab still plays.
  }
}

/**
 * Forget the kept game, but only if it's still the one with `token`
 * (another tab may have joined a newer game since). No token: forget it.
 */
export function clearSession(token = null) {
  try {
    if (token && loadSession()?.token !== token) return;
    window.localStorage.removeItem(KEY);
  } catch {
    // Nothing kept, nothing to clear.
  }
}

/** A code as the server reads it: upper case, no spaces or dashes. */
export function normalizeCode(raw) {
  return (raw || "").toUpperCase().replace(/[\s-]/g, "");
}

/**
 * Where the text cursor sits in an input, in client pixels: what the
 * join screen's creature watches while someone types. Measured with a
 * canvas in the input's own font; null if anything is missing.
 */
export function caretPoint(input) {
  if (!input || typeof document === "undefined") return null;
  const rect = input.getBoundingClientRect();
  const style = window.getComputedStyle(input);
  const canvas = caretPoint.canvas || (caretPoint.canvas = document.createElement("canvas"));
  const context = canvas.getContext?.("2d");
  let width = 0;
  if (context) {
    context.font = style.font || `${style.fontSize} ${style.fontFamily}`;
    const upTo = input.selectionStart ?? input.value.length;
    width = context.measureText(input.value.slice(0, upTo)).width;
  }
  const padding = parseFloat(style.paddingLeft) || 0;
  return {
    x: Math.min(rect.right, rect.left + padding + width - input.scrollLeft),
    y: rect.top + rect.height / 2,
  };
}
